import { LocalityFilter, CountryFilter, ProvinceFilter } from '../geography';
import { DocumentTypeFilter, SexFilter, RelevancePatientFilter } from '.';
import { Auditable } from '../base/auditable';
import { Plan } from '../entity/plan';
import { AliquotTax } from '../aliquot-tax';
import { PhysicianFilter } from '../physician-Filter';
import { PracticeRegionFilter } from '../practice-region-filter';
import { DiagnosticFilter } from '../diagnostic-filter';

export class PatientEditInfo extends Auditable {
  public InAutoGestion: boolean;
  public ViewResultWeb?: boolean;
  public Height?: number;
  public LastName: string;
  public CredentialNumber: string;
  public FirstName: string;
  public CellPhone: string;
  public AddressStreet: string;
  public AddressDpto: string;
  public AddressNumber: string;
  public AddressCP: string;
  public Floor: string;
  public Email: string;
  public EmergencyPhone: string;
  public LaborPhone: string;
  public PersonalPhone: string;
  public Claustrophobia: boolean;
  public Confidential: boolean;
  public AcceptConfirm: boolean;
  public Checked: boolean;
  public DisabilityPermanent: boolean;
  public DisabilityTemporal: boolean;
  public Pacemaker: boolean;
  public MetallicPart: boolean;
  public Id: number;
  public BirthDate?: Date;
  public Number?: number;
  public Weight?: number;
  public Relevances: RelevancePatientFilter[];
  public Diagnostics: DiagnosticFilter[];
  public Locality: LocalityFilter;
  public Country: CountryFilter;
  public Province: ProvinceFilter;
  public DocumentType?: DocumentTypeFilter;
  public Sex: SexFilter;
  public Qr: string;
  public MotherFirstName: string;
  public MotherLastName: string;
  public FatherFirstName: string;
  public FatherLastName: string;
  public FreeDiagnostic: string;
  public Plan: Plan;
  public AliquotTax: AliquotTax;
  public ReferringPhysicianAllowed: boolean;
  public PhysicianId?: number;
  public BudgetTime?: number;
  public AddAutomaticPhysicianInPatient: boolean;
}
